module.exports = __webpack_public_path__ + "static/media/sun.c21c83d8.svg";